import React, { Fragment } from 'react'
import { Col, Container, Row } from 'reactstrap';
import RetentionSection from './components/RetentionSection';

const Retention = () => {
    return (
        <Fragment>
            <Container className="dashboard">
                <Row>
                    <Col md={12}>
                        <h3 style={{ marginBottom: 15 }}>Retencion a Facturas</h3>
                    </Col>
                </Row>
                <Row>
                    <RetentionSection />
                </Row>
            </Container>
        </Fragment>
    )
}

export default Retention